import { PostSignFile } from "./ApiCalls/signFile/postSignFile";
import { GetSignFiles } from "./ApiCalls/signFile/getSignFiles";
import { formatToSpanishTimeZone } from "../utils/formatDate";
import { DeleteSignFile } from "./ApiCalls/signFile/deleteSignFile";

const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const modifiedBy = authInfo.idUser;

export async function PostSignFileService(signFile) {
    const responseSignFile = PostSignFile(signFile, modifiedBy);
  
    return responseSignFile;
  }

  export async function GetSignFilesService(company){
    const signFileResponse = await GetSignFiles(company);

    const signFileData = signFileResponse.map(file =>({
        signFile: file.signFile1,
        company : file.company,
        mimeType: file.mimeType,
        fileName: file.fileName,
        fileData: file.fileData,
        type: file.type,
        createdAt: formatToSpanishTimeZone(file.createdAt)
    }))

    return signFileData;
  }

  export async function DeleteSignFileService(signFile){

    const response = await DeleteSignFile(signFile);

    return response;
  }